import { useQuery, UseQueryOptions } from "react-query";

import { ApiError, SampleRequest, SampleRequestService } from "../api/public";

export const pendingSampleRequestQueryKey = () => "pending-sample-request";

export const useGetPendingSampleRequestQuery = (
  options?: UseQueryOptions<
    SampleRequest | undefined,
    ApiError,
    SampleRequest | undefined,
    string
  >
) => {
  return useQuery<
    SampleRequest | undefined,
    ApiError,
    SampleRequest | undefined,
    string
  >(
    pendingSampleRequestQueryKey(),
    async () =>
      SampleRequestService.sampleRequestGetPendingSampleRequest().then(
        ({ data }) => data
      ),
    options
  );
};
